// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    cardImagesArray: [],
    cardStandardSelected: '',
    cardSubTypeSelected: '',
    cardTypeSelected: '',
    cardImageSelected: '',
    cardURLImage: '',
});

const cardImages = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case actionTypes.GET_CARD_IMAGES:
            return state.merge({
                cardImagesArray: Immutable.fromJS(action.data),
            });
        case actionTypes.GET_DEBIT_CARDS:
            return state.merge({
                cardImagesArray: Immutable.fromJS(action.data),
            });
        case actionTypes.UPDATE_CARD_INFO:
            return state.merge({
                cardStandardSelected: action.data.standard,
                cardSubTypeSelected: action.data.subtype,
                cardTypeSelected: action.data.type,
                cardImageSelected: action.data.id,
                cardURLImage: action.data.urlImage,
            });
        default:
            return state;
    }
};

module.exports = cardImages;
